// semeia-disable-reexport
import { bioExamResultCodeFromOrderCode } from "core/config/bio-exam-result-from-order";
import { ExpectedDosage } from "core/models/bio-exam-expected-dosage-changed-journal-event";
import Patient from "core/models/patient";
export function getNewExpectedDosages(patient) {
  const lastDosageExpected = patient.bioExamExpectedDosageChangedJournalEvent;
  if (lastDosageExpected == undefined) return undefined;
  const newDosages = lastDosageExpected.expectedDosages.map(dosage => {
    return bioExamResultCodeFromOrderCode[dosage.code] ? {
      code: bioExamResultCodeFromOrderCode[dosage.code],
      min: dosage.min,
      max: dosage.max
    } : dosage;
  });
  const expectedDosages = {};
  for (const expectedDosage of newDosages) {
    // TODO: this should contain references to BioExamResultCode, not another kind of object.
    expectedDosages[expectedDosage.code] = {
      code: expectedDosage.code,
      minReferenceValue: expectedDosage.min,
      maxReferenceValue: expectedDosage.max
    };
  }
  return expectedDosages;
}
export function getExpectedDosagesByCode(patient) {
  const expectedDosageByCode = new Map();
  const expectedDosageJes = patient.bioExamExpectedDosageChangedJournalEvents;
  expectedDosageJes.forEach(je => {
    je.expectedDosages.forEach(expectedDosage => {
      const code = bioExamResultCodeFromOrderCode[expectedDosage.code];
      if (!expectedDosageByCode.has(code)) {
        expectedDosageByCode.set(code, []);
      }
      expectedDosageByCode.get(code).push({
        min: expectedDosage.min,
        max: expectedDosage.max,
        date: je.occurredAt
      });
    });
  });
  return expectedDosageByCode;
}